import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { enableRipple } from "@syncfusion/ej2-base";
//import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import { CredsContext } from "./Contexts";
import "./styles/CredentialsViewComponent.css";

function CredentialsViewComponentMain(props) {
  const creds = useContext(CredsContext).creds;
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisible = () => {
    setPasswordVisible(!passwordVisible);
  };

  //const boxSize = props.boxSize;
  //let boxSize = "normal";
  //if (props.boxSize == "large") {
  //  boxSize = "large";
  //}

  return (
    <Box
      alignContent="center"
      sx={{
        padding: "1px",
        border: "none",
        textAlign: "center",
        verticalAlign: "middle",
      }}
    >
      <RadioGroup
        name="row-radio-buttons-group"
        value={creds.instanceType}
        onChange={props.radioChangeHandler}
        row={true}
        sx={{
          alignContent: "center",
          textAlign: "center",
          backgroundColor: "white",
          width: "248px",
          margin: "0px 0px 0px 100px",
        }}
      >
        <Radio
          name="instance"
          value="Sandbox"
          id="sandbox"
          sx={{ display: "table-cell" }}
        />
        <Typography
          sx={{ padding: "10px 10px 0px 2px", display: "table-cell" }}
        >
          Sandbox
        </Typography>

        <Radio
          name="instance"
          value="Production"
          id="production"
          sx={{ display: "table-cell" }}
        />
        <Typography sx={{ padding: "10px 2px", display: "table-cell" }}>
          Production
        </Typography>
      </RadioGroup>
      <div className="e-input-group" style={{ width: "248px" }}>
        <input
          id="companyField"
          value={creds.orig_company}
          onChange={props.inputChangeHandler}
          onKeyDown={props.handleKeyPress}
          className="e-input"
          name="input"
          type="text"
          placeholder="Company"
          style={{
            fontSize: "medium",
            padding: "10px 10px 0px 10px",
            marginTop: "8px",
            borderRadius: "10px",
            backgroundColor: "white",
          }}
        />
      </div>
      <br></br>
      <div className="e-input-group" style={{ width: "248px" }}>
        <input
          id="usernameField"
          value={creds.orig_username}
          onChange={props.inputChangeHandler}
          onKeyDown={props.handleKeyPress}
          className="e-input"
          name="input"
          type="text"
          placeholder="Username"
          style={{
            fontSize: "medium",
            padding: "10px 10px 0px 10px",
            borderRadius: "10px",
            backgroundColor: "white",
            marginTop: "5px",
          }}
        />
      </div>
      <br></br>
      <div className="e-input-group" style={{ width: "248px" }}>
        <input
          id="passwordField"
          value={creds.password}
          onChange={props.inputChangeHandler}
          onKeyDown={props.handleKeyPress}
          className="e-input"
          name="input"
          type={passwordVisible ? "text" : "password"}
          placeholder="Password"
          style={{
            fontSize: "medium",
            padding: "10px 10px 0px 10px",
            borderRadius: "10px",
            backgroundColor: "white",
            marginTop: "5px",
          }}
        />
        <span
          style={{ fontSize: "x-large", backgroundColor: "white" }}
          className="e-input-group-icon e-icons e-eye"
          onClick={togglePasswordVisible}
        />
      </div>
    </Box>
  );
}

export default CredentialsViewComponentMain;

CredentialsViewComponentMain.propTypes = {
  inputChangeHandler: PropTypes.func,
  radioChangeHandler: PropTypes.func,
  handleKeyPress: PropTypes.func,
  boxSize: PropTypes.string,
};
